import { TweenMax } from 'gsap';
import { enableBodyScroll } from 'body-scroll-lock';

/* eslint no-param-reassign: "error" */
function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
}

function hideMenuItems() {
    TweenMax.to('.menu__list li', 0.3, {
        opacity: 0
    });
}

export function closeMenu() {
    const body = document.querySelector('body');
    const menu = document.querySelector('[js-menu="menu"]');
    removeClass(body, 'isMenuOpen');
    document.documentElement.classList.remove('isMenuOpen');
    hideMenuItems();
    enableBodyScroll(menu);

    // Close any open dropdowns when the menu closes
    document.querySelectorAll('.menu__dropdown-trigger').forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
        const dropdown = trigger.nextElementSibling;
        if (dropdown) dropdown.classList.remove('is-open');
    });
}

function initDropdowns() {
    document.querySelectorAll('.menu__dropdown-trigger').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const isOpen = trigger.getAttribute('aria-expanded') === 'true';
            const dropdown = trigger.nextElementSibling;
            if (!dropdown) return;

            // Close all other open dropdowns first
            document.querySelectorAll('.menu__dropdown-trigger').forEach(otherTrigger => {
                if (otherTrigger !== trigger) {
                    otherTrigger.setAttribute('aria-expanded', 'false');
                    const otherDropdown = otherTrigger.nextElementSibling;
                    if (otherDropdown) otherDropdown.classList.remove('is-open');
                }
            });

            // Toggle the clicked one
            trigger.setAttribute('aria-expanded', String(!isOpen));
            dropdown.classList.toggle('is-open', !isOpen);
        });
    });
}

const eventHandler = () => {
    const el = document.querySelector('.js-menu-closer');
    if (el) el.addEventListener('click', closeMenu);

    initDropdowns();
};

const menu = async () => eventHandler();

export default menu;
